module.exports = new __parcel__URL__("sky_loop.9180fdb4.mp4").toString();